import { render, staticRenderFns } from "./CarrinhoEmpresaAgrupamentoFrete.vue?vue&type=template&id=66d84c1a"
import script from "./CarrinhoEmpresaAgrupamentoFrete.vue?vue&type=script&lang=js"
export * from "./CarrinhoEmpresaAgrupamentoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports